import { createSelector } from "reselect";
import { stringSort } from "../constant/filters";

const selectState = (state) => state;

export const selectNetworkActions = createSelector(selectState, (state) => state && state.networkActions);

export const selectIsFetching = (actions) =>
  createSelector(selectNetworkActions, (networkActions) => {
    const pandingNetworkActions = Object.keys(networkActions)
      .filter((actionName) => networkActions[actionName].isFetching)
      .filter((action) => actions.indexOf(action) >= 0);

    return pandingNetworkActions.length > 0;
  });

export const selectNetworkActionsError = (actions) =>
  createSelector(selectNetworkActions, (networkActions) => {
    const pandingNetworkActions = Object.keys(networkActions)
      .filter((actionType) => actions.includes(actionType))
      .reduce((obj, key) => ({ ...obj, [key]: networkActions[key] }), {});
    const fetchingNetworkAction = Object.values(pandingNetworkActions).filter(
      (networkAction) => !networkAction.isFetching && (networkAction.msg || networkAction.code)
    );

    return fetchingNetworkAction;
  });

export const selectToken = createSelector(
  selectState,
  (state) => (state && state.auth && state.auth.accessToken.accessToken) || null
);

export const selectEnvironment = createSelector(selectState, (state) => state && state.environment);

export const selectIsAuthenticated = createSelector(
  selectState,
  (state) => (state && state.auth && state.auth.isAuthenticated) || null
);

export const selectUser = createSelector(selectState, (state) => state && state.user);

export const selectIDPConfig = createSelector(selectState, (state) => state && state.idpConfig);

export const selectOktaClientId = createSelector(selectState, (state) => state && state.oktaClientId);

export const selectIsPhiAllowed = createSelector(selectState, (state) => state && state.isPhiAllowed);

export const selectTier = createSelector(selectState, (state) => state && state.tier);

export const selectSettings = createSelector(selectState, (state) => state && state.settings);

export const selectShowContactSupportModal = createSelector(
  selectState,
  (state) => state && state.showContactSupportModal
);

export const selectMenuItems = createSelector(selectSettings, (settings) => {
  const insightsMenuItems = settings["insights2.tableau.dashboard.urls.list"];
  if (!insightsMenuItems) {
    return [];
  } else {
    const items = JSON.parse(insightsMenuItems.value);
    return items;
  }
});

export const selectShowSkipOrder = createSelector(
  selectSettings,
  (settings) => settings?.["pharmacy.show-skip-order"]?.value === "true"
);

export const selectTableauToken = createSelector(selectState, (state) => state && state.tableauToken);

export const selectUserId = createSelector(selectUser, (user) => user && user.id);

export const selectFilters = createSelector(selectState, (state) => state && state.filters);

export const selectProvidersFacility = createSelector(selectState, (state) => state && state.providers);

export const selectAssignees = createSelector(selectState, (state) => state && state.assignees);

export const selectMultiples = createSelector(selectState, (state) => state && state.multiples);

export const selectReportData = createSelector(selectState, (state) => state && state.reportData);

export const selectReportColumns = createSelector(selectState, (state) => state && state.reportColumns);
export const selectEnrollmentsReportData = createSelector(selectState, (state) => state && state.enrollmentsReportData);

export const selectEnrollmentClaimsReportData = createSelector(
  selectState,
  (state) => state && state.enrollmentClaimsReportData
);

export const selectClaimsReportData = createSelector(selectState, (state) => state && state.claimsReportData);

export const selectInsightsClaimsReportData = createSelector(
  selectState,
  (state) => state && state.insightsClaimsReportData
);

export const selectUserGroups = createSelector(selectState, (state) => state && state.userGroups);

export const selectAssigneesAndUserGroups = createSelector(
  [selectAssignees, selectUserGroups],
  (assignees, userGroups) => {
    const ASSIGNEE_TYPE = 1;
    const USER_GROUP_TYPE = 2;

    if ((!assignees || !assignees.length) && (!userGroups || !userGroups.length)) return [];

    assignees.forEach((assignee) => {
      assignee.displayName = `${assignee.lastName} ${assignee.firstName}`;
      assignee.assigneeType = ASSIGNEE_TYPE;
      assignee.type = "user";
    });

    const parsedUserGroups = Object.values(userGroups);
    parsedUserGroups.forEach((userGroup) => {
      userGroup.displayName = userGroup.name;
      userGroup.assigneeType = USER_GROUP_TYPE;
      userGroup.type = "user-group";
    });

    const assigneesAndUserGroups = assignees
      .concat(parsedUserGroups)
      .sort((itemA, itemB) => stringSort(itemA.displayName, itemB.displayName));

    return assigneesAndUserGroups;
  }
);

export const selectOrdersReportData = createSelector(selectState, (state) => state && state.ordersReportData);

export const selectCompletedOrdersReportData = createSelector(
  selectState,
  (state) => state && state.completedOrdersReportData
);
